'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

import { generateRandomString } from '@src/quince-site-common/src/utils/stringUtil'
import { getCurrentFindingMethod } from '@src/telemetry/findingMethod'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

export function useOnRouteUpdate() {
  const prevPathnameRef = useRef<string>()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const prevPathname = prevPathnameRef.current
    if (!prevPathname || pathname !== prevPathname) {
      const currentFindingMethod = getCurrentFindingMethod()
      trackEvent(TELEMETRY_EVENT_NAMES.PAGE_VIEW, {
        context: {
          findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
          findingMethodGranular: currentFindingMethod?.findingMethodGranular,
          findingMethodId: currentFindingMethod?.findingMethodId,
        },
      })
    }
    if (prevPathname && pathname !== prevPathname) {
      window.__client_side_navigation__ = true
    }
    window.__unique_path_hash__ = generateRandomString()

    return () => {
      prevPathnameRef.current = pathname
    }
  }, [pathname, searchParams])
}
